/**
 * API de partners/colaboradores usando Axios.
 */
import { axiosInstance } from "features/shared/api";
import type { PaginatedPartnersDto } from "common/models";

export type PartnerType = "online-store" | "physical-store" | "online-and-physical-store" | "giftcard";

export interface FindPartnersParams {
    page?: number;
    pageSize?: number;
    query?: string;
    order?: "ASC" | "DESC";
    orderBy?: string;
    type?: PartnerType;
    organizationAddress?: string;
    archived?: boolean;
    belongsToOtherAlly?: boolean;
    parentAddress?: string;
}

export const partnersApi = {
    findAll: (params: FindPartnersParams) =>
        axiosInstance.get<PaginatedPartnersDto>("/api/partners", { params }),

    findRandomPartners: (params: {
        page?: number;
        pageSize?: number;
        belongsToOtherAlly?: boolean;
    }) =>
        axiosInstance.get<PaginatedPartnersDto>("/api/partners/random-partners", {
            params,
        }),
};
